export function calcMenuItemPriceRange(menu, itemId) {
    return calcMenuItemPriceRangeImpl(menu, itemId, 0, undefined);
}
function calcMenuItemPriceRangeImpl(menu, itemId, depth, variationBasePrice) {
    var item = menu.items.find(function (i) { return i.id === itemId; });
    if (!item) {
        throw new Error("calcMenuItemPriceRangeImpl: Item " + itemId + " was not found in menu");
    }
    // In case item is a variation choice of a different item, override
    // the menu price with the base price from the original item's variation.
    var basePrice = variationBasePrice !== undefined ? variationBasePrice : item.price || 0;
    var result = {
        min: basePrice,
        max: basePrice,
        maxPriceOfMandatoryChoices: basePrice,
    };
    if (depth >= 4) {
        return result;
    }
    (item.variations || []).forEach(function (variation) {
        var variationPriceRange = calcVariationPriceRange(menu, variation, depth);
        result.min += variationPriceRange.min;
        result.max += variationPriceRange.max;
        result.maxPriceOfMandatoryChoices +=
            variationPriceRange.maxPriceOfMandatoryChoices;
    });
    return result;
}
function calcVariationPriceRange(menu, variation, depth) {
    var minimalItems = variation.minNumAllowed || 0;
    var maximalItems = variation.maxNumAllowed || Number.MAX_VALUE;
    var ascendingMinPrices = [];
    var ascendingMaxPriceOfMandatoryChoicesPrices = [];
    var ascendingMaxPrices = [];
    variation.itemIds.forEach(function (id) {
        var _a;
        var priceRange = calcMenuItemPriceRangeImpl(menu, id, depth + 1, ((_a = variation.prices) === null || _a === void 0 ? void 0 : _a[id]) || 0);
        ascendingMinPrices.push(priceRange.min);
        ascendingMaxPriceOfMandatoryChoicesPrices.push(priceRange.maxPriceOfMandatoryChoices);
        ascendingMaxPrices.push(priceRange.max);
    });
    ascendingMinPrices.sort(function (a, b) { return a - b; });
    ascendingMaxPriceOfMandatoryChoicesPrices.sort(function (a, b) { return a - b; });
    ascendingMaxPrices.sort(function (a, b) { return a - b; });
    var result = {
        min: 0,
        maxPriceOfMandatoryChoices: 0,
        max: 0,
    };
    result.min = ascendingMinPrices.slice(0, minimalItems).reduce(reduceSum, 0);
    result.maxPriceOfMandatoryChoices = ascendingMaxPriceOfMandatoryChoicesPrices
        .slice(ascendingMaxPrices.length - minimalItems, ascendingMaxPrices.length)
        .reduce(reduceSum, 0);
    result.max = ascendingMaxPrices
        .slice(ascendingMaxPrices.length - maximalItems, ascendingMaxPrices.length)
        .reduce(reduceSum, 0);
    return result;
}
function reduceSum(previousValue, currentValue) {
    return previousValue + currentValue;
}
//# sourceMappingURL=priceRangeLogic.js.map